<template>
  <div>
    <AssignedToCard v-if="showDependents" />
    <HraRiskSummaryCard v-if="isHra && hasHraRisk && !!hraOverallRisk" />
    <OverviewCard v-if="longDescription" />
    <SurveyCard v-if="supportsSurvey" />

    <SchedulerCard v-if="hasSchedulerConfig" />

    <HraCard v-if="isHra" />
    <MrosSurvey v-else-if="isMrosSurvey" />
    <EducationBundle v-else-if="isEducationBundle" />
    <QuestionnaireToDoCard v-else-if="isQuestionnaireToDo" />
    <CompoundHealthActionCard v-else-if="isCompoundHealthAction" />
    <OnlineSchedulingCard v-else-if="isToBeScheduledOnline" />
    <ToDoCard v-else />
  </div>
</template>

<script>
import CompoundHealthActionCard from './CompoundHealthActionCard'
import OverviewCard from './OverviewCard'
import ToDoCard from './ToDoCard'
import EducationBundle from './EducationBundle'
import MrosSurvey from './MrosSurvey'
import healthActionMixin from '@platform-shared/mixins/health-actions/healthActionMixin.js'
import AssignedToCard from './AssignedToCard.vue'
import HraCard from './hra/HraCard.vue'
import HraRiskSummaryCard from './hra/HraRiskSummaryCard.vue'
import QuestionnaireToDoCard from './questionnaire-todo/QuestionnaireToDoCard'
import SurveyCard from './survey/SurveyCard.vue'
import OnlineSchedulingCard from './scheduling/OnlineSchedulingCard'
import SchedulerCard from './scheduler/SchedulerCard.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    CompoundHealthActionCard,
    OverviewCard,
    ToDoCard,
    EducationBundle,
    MrosSurvey,
    AssignedToCard,
    HraCard,
    HraRiskSummaryCard,
    QuestionnaireToDoCard,
    SurveyCard,
    OnlineSchedulingCard,
    SchedulerCard,
  },
  mixins: [healthActionMixin],
  computed: {
    ...mapGetters('scheduling', ['scheduledAppointment']),
  },
  mounted() {
    if (this.isToBeScheduledOnline && !this.scheduledAppointment) {
      this.fetchScheduledAppointment()
    }
  },
  methods: {
    ...mapActions('scheduling', ['fetchScheduledAppointment']),
  },
}
</script>
